import gql from 'graphql-tag';
import { compose } from 'ramda';

import { selectParams } from '#src/store/location/selectors';
import { setInvite } from '#src/store/content/actions';
import { toNotFound } from '#src/store/location/actions';

const query = gql`
  query Invite($token: String) {
    invite(token: $token) {
      id
      token
      creditAmountCents
      gameId
      game {
        id
        isTeamGame
        betAmount
        displayCategory
        title
        imageUrl
        image {
          publicId
          url
        }
      }
      userId
      user {
        id
        firstName
        displayName
        avatarV2 {
          value
          type
        }
      }
    }
  }
`;

export const path = '/invite/:inviteToken';
export const component = 'InviteLanding';
export const thunk =
  ({ graphqlClient }) =>
  async (dispatch, getState) => {
    const { inviteToken } = selectParams(getState());
    const { data } = await graphqlClient.query({
      query,
      fetchPolicy: 'network-only',
      variables: { token: inviteToken },
    });

    const { invite } = data || {};
    if (!invite) {
      dispatch(toNotFound());
      return;
    }
    compose(dispatch, setInvite)(invite);
  };
